<template>
  <div id="testimonials" class="bg-grey-lightest pt-12 pb-12">
    <div class="text-2xl italic text-center">
      质量与认证
      </div>
      <carousel :per-page="1" class="text-black" autoplay loop paginationColor="#000000" paginationActiveColor="#388E3C">
        <slide v-for="testimonial in testimonials" :key="testimonial.id">
          <div class="text-center">
        <div class="text-2xl italic">
          <!-- {{ testimonial.title}} -->
        </div>
        <p class="text-black font-base text-md m-10">
          {{ testimonial.message }}
        </p>
        <!-- <div class="inline-flex">
            <img :src="'avatars/' + testimonial.icon" alt="avatar" class="h-16">
          <div class="text-black mt-3 ml-6">
            <div class="font-medium text-lg">
              {{ testimonial.name }}
            </div>
            <div class="font-thin text-md opacity-75">
              {{ testimonial.job }}
            </div>
          </div>
        </div> -->
      </div>
        </slide>
      </carousel>
    </div>
  <!-- </div> -->
</template>

<script>
  export default {
    data() {
      return {
        testimonials: [
          {
            id: 1,
            title: '荣誉',
            message: '广州市药品零售业GSP专项认证'
          },
          {
            id: 2,
            title: '',
            message: '与多家大型供货商保持紧密合作，确保药品质量和品种齐全'
          }
        ]
      };
    },
    mounted(){
      // axios.get('testimonials.json').then(response => (
      //   this.testimonials = response.data
      //   ))
    }
  };
</script>

